export default __webpack_public_path__ + "static/media/user_black.b7f80a89.svg";